<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about knife">
    <Head title="ナイフ買取り" />
    <div class="m-auto">
      <h2 class="mb-[30px] xs:mb-[40px] sm:mb-[50px] md:mb-[60px]"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/knife_main.jpg" alt="A&amp;Fナイフ買取り" class="block mx-auto" /></h2>
      <div class="mx-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[900px] pb-[60px] sm:pb-[80px] md:pb-[100px] lg:pb-[120px]">
        <h2 class="!text-[20px] sm:!text-[22px] lg:!text-[24px] mb-[1em] sm:mb-[1.2em]">ハンドメイドカスタムナイフの買い取りのご案内</h2>
        <p class="lead">
          エイアンドエフではハンドメイドカスタムナイフの買い取りを行なっております。<br class="hidden sm:block" />
          R.W.Loveless, W.D.Randall, Jess Hornのハンドメイドカスタムナイフをお高く買い取り致します。
        </p>
        <dl class="notice mb-[40px] sm:mb-[50px]">
          <div>
            <dt>※</dt>
            <dd class="!w-[calc(100%_-_2em)]">恐れ入りますが、ハンドメイドカスタムナイフ以外の工場生産されたナイフは買い取りを行なっておりません。</dd>
          </div>
        </dl>

        <h3>【直接店頭<small class="text-[90%]">（A&amp;Fカントリー 新宿本店）</small>へお持ち頂ける場合】</h3>
        <p>商品を見て価格をお伝えし、了承頂ければ、その場でお支払いいたします。</p>
        <dl class="notice">
          <div>
            <dt>注意1：</dt>
            <dd>身分の証明できるもの（免許証、パスポート等）の提示が必要になります。</dd>
          </div>
          <div>
            <dt>注意2：</dt>
            <dd>担当が不在の場合、査定もしくはお支払いに数日かかる場合がございます。</dd>
          </div>
        </dl>

        <h3>【こちらへお送りいただく場合】</h3>
        <p>必ず佐川急便、ヤマト便、郵便書留にてお送り下さい。<br class="hidden sm:block" />その際に連絡できる電話番号かメールアドレスを知らせてください。<br class="hidden sm:block" />到着次第買取価格をお知らせ致します。</p>
        <dl class="notice">
          <div>
            <dt>注意1：</dt>
            <dd>身分の証明できるもの（免許証、パスポート等）のコピーを1点、<br class="hidden lg:block" />住民票の写し等（市区町村で発行を受けた「住民票の写し」「戸籍沙本・謄本」「印鑑登録証明書」等）を1点、<br class="hidden lg:block" />計2点を必ず同封してください。</dd>
          </div>
          <div>
            <dt>注意2：</dt>
            <dd>担当が不在の場合、査定もしくはお支払いに数日かかる場合がございます。</dd>
          </div>
        </dl>

        <p class="!my-[40px] sm:!my-[50px]">いずれの例でも事前にメールか電話でメーカー名、モデル、状態をご連絡下されば、おおよその価格をお知らせいたします。</p>

        <h4>ナイフ所持・携帯に関する注意事項</h4>
        <p class="link">
          以下の参考サイトをお読み下さい<br />
          ジャパン ナイフ ギルド：<a href="http://www.jkg.jp/law.htm" class="text-afgreen hover:text-afgreen-light" target="_blank">http://www.jkg.jp/law.htm</a>
        </p>

        <div class="info">
          <h4>株式会社エイアンドエフ</h4>
          <p>
            東京都新宿区新宿6丁目27番地56号 新宿スクエア8F<br />
            電　話：03-3209-7575<br />
            メール：<a href="mailto:info@aandf.co.jp?subject=カスタムナイフの買取りの問い合わせ" class="text-afgreen hover:text-afgreen-light">info@aandf.co.jp</a><br />
            担　当：赤津孝夫
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
